<script setup lang="tsx">
import type { RiskConfig, RiskShort } from '@/models/api-generated'
import { formatRiskScoreStr } from '../shared'
import CardRow from './CardRow.vue'
import { scoreToLevel } from '../shared'
import { truncate } from '@/services/utils'

const props = defineProps<{
	config?: RiskConfig
}>()

const model = defineModel<RiskShort[]>({ required: true })

const emit = defineEmits<{
	(e: 'go-to-risks', riskNames: string[], treatments: string[]): void
}>()

function goToRisks(name: string) {
	if (!name) return
	emit('go-to-risks', [name], [])
}
</script>

<template>
	<div class="rounded-container p-4 overflow-auto text-nowrap">
		<p class="text-center fw-bold">
			{{ $t('risk.overview.highRiskScore') }}
		</p>

		<table class="w-100">
			<CardRow :underline="true">
				<template #col0>
					<b>{{ $t('risk.acceptable') }}</b>
				</template>
				<template #col_end>
					<span v-if="props.config" class="green">{{ formatRiskScoreStr(props.config.acceptableRisk, undefined, props.config) }}</span>
				</template>
			</CardRow>

			<CardRow v-for="a in model" :key="a.name">
				<template #col0>
					<span class="badge bg-primary me-2 fixed-badge" v-one-tooltip="a.asset.name ? a.asset.name : $t('risk.default')">
						{{ a.asset.id > 0 ? a.asset.name : $t('risk.default') }}
					</span>
					<i class="bi bi-circle-fill me-2 ms-2" :style="{ color: scoreToLevel(a.residual, props.config)?.color || 'gray' }"> </i>
					{{ a.code }}
					<span v-one-tooltip="a.name" @click="goToRisks(a.name)" class="risks-cell"> {{ truncate(a.name, 20) }}</span>
				</template>
				<template #col_end>
					<span class="orange">{{ formatRiskScoreStr(a.residual, 1, props.config) }}</span>
				</template>
			</CardRow>
		</table>
	</div>
</template>
